<template>
  <div class="contract-rule-bd tb" v-if="funcView.sharingRule_list">
    <div class="search-hd">
      <el-form :inline="true">
        <el-form-item>
          <el-button @click="addRule" type="primary" icon="el-icon-plus" v-if="funcView.sharingRule_add">{{funcView.sharingRule_add}}</el-button>
        </el-form-item>
        <!-- 配置项 -->
        <el-form-item style="float: right; margin-right: 0">
          <custom-column :code="tableCode" v-model="tableColumn"></custom-column>
        </el-form-item>
        <!-- 产品型号 -->
        <el-form-item style="float: right">
          <custom-select
            :filterable="true"
            v-model="formSearch.productCode"
            url="productCodeSelectList"
             :props="{ label: 'productName', value: 'productCode' }"
            :placeholder="$t('crm_contract_rule.chan_pin_xing_hao')"
            width="160px"
            @change="onPageChange({ page: 1 })"
          ></custom-select>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-bd">
      <custom-table height="100%" :data="tableList" :column="tableColumn" @sort="sortChange" @filter="filterChange">
        <template  slot="action" slot-scope="scope">
          <el-button type="text" size="mini" @click="editRule(scope.row)" v-if="funcView.sharingRule_edit">{{funcView.sharingRule_edit}}</el-button>
          <el-button type="text" size="mini" @click="deleteRule(scope.row)" v-if="funcView.sharingRule_delete">{{funcView.sharingRule_delete}}</el-button>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';

export default {
  name: 'contract_contractrule',
  data() {
    return {
      tableCode: 'divide_rule',

      tableList: [],
      totalRows: 0,

      formSearch: {
        search: '',
        orderBy: '',
        orderType: '',
        productCode: '',
        pageSize: 50,
        pageNum: 1
      }
    };
  },
  mounted() {
    this.getTableColumn();
    this.getFuncView();

    this.getTableList();
  },
  methods: {
    // 获取表格数据
    getTableList: function () {
      this.$getJSON(apis.SharingRulePage, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    // 新增规则
    addRule: function () {
      this.clearTagByKeep('contract_rule_item');
      this.jump('/redirect/offer/contractrule/add', { parentPath: '/offer/contractrule' });
    },
    // 编辑规则
    editRule: function (row) {
      this.clearTagByKeep('contract_rule_item');
      this.jump('/redirect/offer/contractrule/edit', { parentPath: '/offer/contractrule', productCode: row.productCode });
    },
    // 删除规则
    deleteRule: function (data) {
      this.$showConfirm(this.$t('crm_contract_rule.qrscgfcgzm')).then(() => {
        this.$postJSON(`${apis.SharingRuleDelete}/${data.sharingRuleId}`).then(() => {
          this.$message({
            message: this.$t('Common.com_handle_success'),
            type: 'success'
          });
          this.getTableList();
        });
      });
    }
  }
};
</script>

<style lang="scss">
@import '../../../style/colors.scss';

.contract-rule-bd {
  .aside {
    .title {
      padding: 14px 10px 16px 12px;
      line-height: 24px;
      color: #404040;
      font-weight: bold;
      font-size: 16px;
      .icon {
        font-weight: normal;
        float: left;
        margin-right: 8px;
        font-size: 14px;
      }
    }
    .search {
      margin: 0 10px;
    }
    .is-current > .el-tree-node__content {
      background-color: $main-color;
      .tree-item {
        color: #ffffff;
        .icon {
          color: #ffffff;
          font-size: 12px;
        }
        .disable {
          color: #ffffff;
        }
      }
    }
    .tree-item {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 12px;
      padding-right: 8px;
      width: 0;
      .disable {
        color: #bfbfbf;
      }
    }
  }
}
</style>
